import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import SectionHeading from "./SectionHeading";

export default function Gallery() {
  const wedding = useContent();
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => {
    if (embla) setSelected(embla.selectedScrollSnap());
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    embla.on("select", onSelect);
  }, [embla, onSelect]);

  return (
    <section id="galeria" className="bg-ink text-white py-24 sm:py-36 grain relative">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <SectionHeading number="02" kicker="Nosotros" title="Nuestra Historia" dark />
      </div>

      <div className="relative mt-4">
        <button
          onClick={() => embla && embla.scrollPrev()}
          className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 z-10 w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-ink/50 backdrop-blur-md border border-white/40 text-white flex items-center justify-center hover:bg-white hover:text-ink transition-colors duration-300"
          aria-label="Anterior"
          data-testid="gallery-prev"
        >
          <ArrowLeft size={20} strokeWidth={1.4} />
        </button>
        <button
          onClick={() => embla && embla.scrollNext()}
          className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 z-10 w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-ink/50 backdrop-blur-md border border-white/40 text-white flex items-center justify-center hover:bg-white hover:text-ink transition-colors duration-300"
          aria-label="Siguiente"
          data-testid="gallery-next"
        >
          <ArrowRight size={20} strokeWidth={1.4} />
        </button>

        <div className="overflow-hidden" ref={emblaRef} data-testid="gallery-carousel">
          <div className="flex gap-4 sm:gap-6 px-6 sm:px-10">
            {wedding.gallery.map((src, i) => (
              <div
                key={i}
                className="relative shrink-0 basis-[78%] sm:basis-[42%] lg:basis-[30%] group cursor-grab active:cursor-grabbing"
              >
                <div className="overflow-hidden aspect-[3/4] bg-white/5">
                  <img
                    src={src}
                    alt={`Carolina y Roberto ${i + 1}`}
                    className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                    loading="lazy"
                    data-testid={`gallery-image-${i}`}
                  />
                </div>
                <span className="mt-3 block overline text-white/40">
                  {String(i + 1).padStart(2, "0")} / {String(wedding.gallery.length).padStart(2, "0")}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 mt-10">
        <div className="h-px bg-white/10 relative overflow-hidden">
          <div
            className="h-px bg-white transition-[width] duration-500"
            style={{ width: `${((selected + 1) / wedding.gallery.length) * 100}%` }}
          />
        </div>
      </div>
    </section>
  );
}
